var map = {
	"./logo-chat-sm.svg": 24901,
	"./promo.svg": 38249,
	"./site-logo-desktop-footer.svg": 33848,
	"./site-logo-drawer-mobile.svg": 55138,
	"./site-logo-drawer.svg": 64547,
	"./site-logo-tv.svg": 45286,
	"./site-logo-wrapper-mobile-scrolled.svg": 80909,
	"./site-logo-wrapper-mobile.svg": 76104,
	"./site-logo-wrapper-scrolled.svg": 77954,
	"./site-logo-wrapper.svg": 49965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69231;